module.exports = __webpack_public_path__ + "img/cubits_grey_256.96132192.png";